const REVISION_GLOBO_PENDING_CLASS = 'price--globo-pending';
const REVISION_GLOBO_PENDING_ATTR = 'data-globo-price-pending';

function parseDisplayedAmount(text) {
  if (!text) return 0;
  const compact = String(text).replace(/\s/g, '');
  const decimalMatch = compact.match(/(\d+)[.,](\d{2})/);
  if (decimalMatch) {
    return Number(`${decimalMatch[1]}.${decimalMatch[2]}`);
  }
  const integerMatch = compact.match(/(\d+)/);
  return integerMatch ? Number(integerMatch[1]) : 0;
}

function displayedAmountIsPositive(root) {
  const items = root.querySelectorAll('.price-item:not(s)');
  const sources = items.length > 0 ? Array.from(items) : [root];
  return sources.some((element) => parseDisplayedAmount(element.textContent) > 0);
}

function revealIfPriced(root) {
  if (!root || !root.hasAttribute(REVISION_GLOBO_PENDING_ATTR)) return true;
  if (!displayedAmountIsPositive(root)) return false;
  root.classList.remove(REVISION_GLOBO_PENDING_CLASS);
  root.removeAttribute(REVISION_GLOBO_PENDING_ATTR);
  return true;
}

function watchPendingPrice(root) {
  if (revealIfPriced(root)) return;

  const host = root.closest('[id^="price-"]') || root;
  const observer = new MutationObserver(() => {
    if (revealIfPriced(root)) observer.disconnect();
  });
  observer.observe(host, { childList: true, subtree: true, characterData: true });
}

function bindRevisionGloboPrices() {
  document.querySelectorAll(`[${REVISION_GLOBO_PENDING_ATTR}]`).forEach(watchPendingPrice);

  document.addEventListener('change', (event) => {
    const scope = event.target.closest('product-info, .product') || document;
    requestAnimationFrame(() => {
      scope.querySelectorAll(`[${REVISION_GLOBO_PENDING_ATTR}]`).forEach(revealIfPriced);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindRevisionGloboPrices);
} else {
  bindRevisionGloboPrices();
}
